document.addEventListener('DOMContentLoaded', () => {
  // Function to initialize part finders
  function initializeFinders() {
    const finders = document.querySelectorAll('finder-parts');

    finders.forEach((finder) => {
      // Prevent reinitializing already-initialized finders
      if (finder.dataset.initialized === 'true') return;

      const yearDropdown = finder.querySelector('.year-dropdown');
      const makeDropdown = finder.querySelector('.make-dropdown');
      const modelDropdown = finder.querySelector('.model-dropdown');
      const searchButton = finder.querySelector('.search-button'); // Now an <a> tag

      if (!yearDropdown || !makeDropdown || !modelDropdown || !searchButton) return;

      finder.dataset.initialized = 'true'; // Mark finder as initialized

      function addOptions(dropdown, options, defaultTitle) {
        dropdown.innerHTML = `<option value="">${defaultTitle}</option>`;
        options.forEach((optionData) => {
          const option = document.createElement('option');
          option.value = optionData.value || '';
          option.textContent = optionData.text || '';
          if (optionData.disabled) {
            option.disabled = true;
          }
          dropdown.appendChild(option);
        });
      }

      // Populate Year Dropdown
      addOptions(yearDropdown, jsonData.years.map(year => ({
        value: year.year,
        text: year.year
      })), 'Motorcycle Year');

      // Handle Year Dropdown Change
      yearDropdown.addEventListener('change', () => {
        const selectedYear = yearDropdown.value;
        const yearData = jsonData.years.find((y) => y.year === selectedYear);

        if (yearData) {
          const popularMakes = ['Honda', 'Yamaha', 'Kawasaki', 'BMW', 'Ducati', 'Harley Davidson', 'Triumph', 'Suzuki', 'KTM', 'Aprilia'];

          const popularOptions = [];
          const otherOptions = [];

          yearData.makes.forEach((makeData) => {
            const option = { value: makeData.make, text: makeData.make };
            if (popularMakes.includes(makeData.make)) {
              popularOptions.push(option);
            } else {
              otherOptions.push(option);
            }
          });

          popularOptions.sort((a, b) => a.text.localeCompare(b.text));
          otherOptions.sort((a, b) => a.text.localeCompare(b.text));

          const combinedOptions = [
            { value: '', text: '-- Popular Makes --', disabled: true },
            ...popularOptions,
            { value: '', text: '-- Other Makes --', disabled: true },
            ...otherOptions,
          ];

          addOptions(makeDropdown, combinedOptions, 'Motorcycle Make');
          makeDropdown.disabled = false;
        } else {
          makeDropdown.disabled = true;
          addOptions(makeDropdown, [], 'Motorcycle Make');
          addOptions(modelDropdown, [], 'Motorcycle Model');
          modelDropdown.disabled = true;
          searchButton.setAttribute('disabled', 'true'); // Disable search button
          searchButton.removeAttribute('href'); // Clear href
        }
      });

      // Handle Make Dropdown Change
      makeDropdown.addEventListener('change', () => {
        const selectedYear = yearDropdown.value;
        const selectedMake = makeDropdown.value;
        const yearData = jsonData.years.find((y) => y.year === selectedYear);
        const makeData = yearData?.makes.find((m) => m.make === selectedMake);

        if (makeData) {
          const modelOptions = makeData.models.map((model) => ({
            value: model.collection_url,
            text: model.name,
          }));

          addOptions(modelDropdown, modelOptions, 'Motorcycle Model');
          modelDropdown.disabled = false;
        } else {
          modelDropdown.disabled = true;
          addOptions(modelDropdown, [], 'Motorcycle Model');
          searchButton.setAttribute('disabled', 'true'); // Disable search button
          searchButton.removeAttribute('href'); // Clear href
        }
      });

      // Handle Model Dropdown Change
      modelDropdown.addEventListener('change', () => {
        if (modelDropdown.value) {
          searchButton.removeAttribute('disabled'); // Enable search button
          searchButton.href = modelDropdown.value; // Set href to the collection URL
        } else {
          searchButton.setAttribute('disabled', 'true'); // Disable search button
          searchButton.removeAttribute('href'); // Clear href
        }
      });
    });
  }

  // Initialize all part finders on page load
  initializeFinders();

  // Safeguarded MutationObserver to watch for menu changes
  const observer = new MutationObserver((mutations) => {
    let foundNewContent = false;

    mutations.forEach((mutation) => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        foundNewContent = true;
      }
    });

    if (foundNewContent) {
      initializeFinders(); // Reinitialize when new elements are added
    }
  });

  // Start observing the body for changes, with safeguards
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
